"use client";

import TeamAvatarStack from "@/components/v3/TeamAvatarStack";

const TeamsHeroContent = () => {
  return (
    <div className="absolute bottom-4 left-4 z-20 flex flex-col gap-3 sm:bottom-8 sm:left-[5%] sm:gap-4 md:bottom-[60px] md:left-[10%] md:gap-6">
      <TeamAvatarStack
        maxVisible={6}
        sizeClassName="size-8 sm:size-9 md:size-10"
        hiddenFromIndex={undefined}
        avatarClassName="bg-[#222]"
        className="flex -space-x-2 sm:-space-x-3"
      />

      <h2 className="font-crimsonText text-xl font-bold leading-tight tracking-wide text-white sm:text-2xl md:text-3xl">
        Team that understands you
      </h2>
    </div>
  );
};

export default TeamsHeroContent;
